import * as svg from "../../../assets/chevron-left-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const ChevronLeftIcon = iconBuilder(svg, "ChevronLeftIcon", "0 0 16 16");
